import {api} from './api';
import { Program, ProgramUser } from '../model/program';
import { Course } from '../model/course';
import { User } from '../model/user';

export const getPrograms = async (accessToken: string): Promise<Program[]> => {
    const response = await api.get<Program[]>(`/programs`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data;
};

export const getProgram = async (accessToken: string, uuid: string): Promise<Program> => {
    const response = await api.get<Program>(`/programs/${uuid}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data;
};

export const putProgram = async (accessToken: string, program: Program): Promise<Program> => {
    const response = await api.put<Program>(`/programs`, 
        program, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data;
};

export const getProgramCourses = async (accessToken: string, uuid: string): Promise<Course[]> => {
    const response = await api.get<Course[]>(`/programs/${uuid}/courses`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data;
};

export const deleteProgram = async (accessToken: string, programId: string): Promise<boolean> => {
    const response = await api.delete<boolean>(`/programs/${programId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return response.status == 204 || response.status == 200
};

export const getProgramUsers = async (accessToken: string, programId: string): Promise<ProgramUser[]> => {
    const response = await api.get(`/programs/${programId}/users`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    })

    return response.data
}

export const addUsersToProgram = async (accessToken: string, program: Program, users: User[]): Promise<ProgramUser[]> => {
    let ids = users.map(user => user.id)

    const response = await api.post<ProgramUser[]>(`/programs/${program.id}/users`, 
        ids, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data;
};

export const removeUserFromProgram = async (accessToken: string, programId: string, userId: string): Promise<boolean> => {
    const response = await api.delete<boolean>(`/programs/${programId}/users/${userId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data;
};